import { type AggregateRating, type Rating } from 'schema-dts'

const BEST_RATING = 5
const WORST_RATING = 1

export const getAggregatedRatingSchema = (
  ratingValue?: number,
  ratingCount?: number,
): AggregateRating | undefined => {
  // falsy values are invalid (0 as well, always should be positive if present)
  if (!ratingCount || !ratingValue || ratingValue < 1) {
    return undefined
  }

  return {
    '@type': 'AggregateRating',
    bestRating: BEST_RATING,
    ratingCount,
    ratingValue,
    worstRating: WORST_RATING,
  }
}

export const getRatingSchema = (rating: number): Rating => ({
  '@type': 'Rating',
  bestRating: BEST_RATING,
  ratingValue: rating,
  worstRating: WORST_RATING,
})
